import { connect } from 'react-redux';

import { getComplaints } from '../../actions/complain';
import { Complaint } from '../../components/Complaint';
import { TThunkDispatch, IApplicationState } from '../../types/redux';

export interface IOwnProps {
  offerId: number;
}

export function mapStateToProps(state: IApplicationState, { offerId }: IOwnProps) {
  return {
    offerId,
    ...state.complain,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch) {
  return {
    getComplaints: () => dispatch(getComplaints()),
  };
}

export const ComplainContainer = connect(mapStateToProps, mapDispatchToProps)(Complaint);
